import {EntityBase} from "../../shared/entity/EntityBase";

const PROBABILITY_FIELDS = {
    seq: { type: Number, defaultValue: 0 },
    data: { type: Object, defaultValue: {} },
    onOff: { type: Number, defaultValue: 0 }, // 0: off, 1: on
}

export class ProbabilityEntity extends EntityBase {
    constructor(data = {}) {
        super(data, PROBABILITY_FIELDS);

        this.errors = [];
    }

    getColumnData() {
        return {
            seq: this.seq,
            onOff: this.onOff,
            ...this.data
        }
    }
}